<div class="flex decorator-strong justify-content-between align-items-center my-4 pb-4">
  <div class="font-semibold text-2xl" data-clarity-unmask="true">Zaproś kursanta</div>
  <i class="pi pi-times secondary-button p-0 mr-2" (click)="closeDialog()"></i>
</div>

<div class="flex flex-column gap-3">
  <div class="flex gap-2">
    <div class="round-indicator">1</div>
    <div class="text-sm">
      Aby kursant mógł dołączyć do Twojego OSK, wyślij mu poniższy link lub
      kod zaproszenia.
    </div>
  </div>
  <div class="flex gap-2">
    <div class="round-indicator">2</div>
    <div class="text-sm">
      Wersja desktop: Po zalogowaniu się do aplikacji wystarczy, że naciśnie
      przycisk <strong>Dołącz</strong> lub wpisze kod zaproszenia w
      <strong>Ustawienia>Dołącz do OSK.</strong><br /><br />
      Wersja mobile: Po zalogowaniu, kursant musi wejść w
      <strong>Ustawienia>Dołącz do OSK</strong> i wpisać kod zaproszenia.
    </div>
  </div>
  <div class="flex gap-2">
    <div class="round-indicator">3</div>
    <div class="text-sm">
      Kursant może należeć tylko do jednego OSK! Jeśli dołączy on do innego
      OSK stracisz możliwość zarządzania nim oraz monitorowania jego
      postępu.
    </div>
  </div>
</div>
<div class="mt-6">
  <div class="form-decorator flex align-items-center gap-2">
    <div class="title">Link</div>
    <div class="form-wraper">
      <div class=""> https://testy-na-prawko.net/app/join/{{oskShortCode}}</div>
    </div>
    <p-button styleClass="w-15rem" label="Skopiuj do schowaka" icon="pi pi-copy" (onClick)="copyLink()" data-clarity-unmask="true"/>
  </div>
</div>

